import ILogger from './ILogger'
import { commonStyles, isObjectValuesAreString, stringifyStyles } from './helpers'
import isObject from 'lodash/isObject'

export default class ConsoleLogger extends ILogger {
  /**
   * @param {object} console
   * @param {function} getContext
   */
  constructor (console, getContext) {
    super()

    this._console = console
    this._getContext = getContext
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   * @throws {TypeError}
   * @private
   */
  _validate (error, extra, tagMap) {
    if (!(error instanceof Error)) {
      throw new TypeError('Error must be instance of Error')
    }

    if (!isObject(extra)) {
      throw new TypeError('extra must be an object')
    }

    if (!isObject(tagMap) || !isObjectValuesAreString(tagMap)) {
      throw new TypeError('tagMap must be valid map')
    }
  }
  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   * @param {string} level
   * @param {object} styles
   * @private
   */
  _log (error, extra, tagMap, level, styles) {
    const stringifiedStyles = stringifyStyles(Object.assign(commonStyles, styles))

    this._console.group(`Track ${level}`)
    this._console.log(`%c   ${level}: ${error.message}   `, stringifiedStyles)
    this._console.error(error)
    this._console.log(`extra: `, extra)
    this._console.log(`tags:`, tagMap)
    this._console.log(`context:`, this._getContext())
    this._console.groupEnd()
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  error (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    const warningStyles = {
      'background-color': '#9c1822'
    }

    this._log(error, extra, tagMap, ILogger.ERROR, warningStyles)
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  warning (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    const warningStyles = {
      'background-color': '#9c9c00'
    }

    this._log(error, extra, tagMap, ILogger.WARNING, warningStyles)
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  info (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    const infoStyles = {
      'background-color': '#3f79ae'
    }

    this._log(error, extra, tagMap, ILogger.INFO, infoStyles)
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  debug (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    const debugStyles = {
      'background-color': '#8bacae'
    }

    this._log(error, extra, tagMap, ILogger.DEBUG, debugStyles)
  }
}



// WEBPACK FOOTER //
// ./src/utils/Logger/ConsoleLogger.js